import { http } from "@/core/api/";
const apiUrl = "api/inventoryTransfer";

export default {
  search(params) {
    return http.get(`${apiUrl}/search`, { params });
  },
  getStatuses() {
    return http.get(`${apiUrl}/statuses`);
  },
  approveTransfer(id, data) {
    return http.patch(`${apiUrl}/book/${id}/transfer/approve`, data);
  },
  rejectTransfer(id, data) {
    return http.patch(`${apiUrl}/book/${id}/transfer/reject`, data);
  },
  sendToRouteInventoryTransfer(id, data) {
    return http.patch(`${apiUrl}/transfer/${id}/sendtoroute`, data);
  },
  get(id) {
    return http.get(`${apiUrl}/${id}`);
  },
  getTransferHistory(transferId) {
    return http.get(`${apiUrl}/transfer/${transferId}/history`);
  },
};
